// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fcis-error{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.fcis-error__notification{width:90%}@media(min-width:48em){.fcis-error__notification{width:600px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
